import { JsonObject, JsonProperty } from 'json2typescript';


@JsonObject('BankDetail')
export class BankDetail {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('client_id', Number, true)
    clientId: number = undefined;

    @JsonProperty('name', String, true)
    name: string = null;

    @JsonProperty('is_primary', Boolean, true)
    isPrimary = true;

    @JsonProperty('street_address', String, true)
    streetAddress: string = null;

    @JsonProperty('city', String, true)
    city: string = null;

    @JsonProperty('country', String, true)
    country: string = null;

    @JsonProperty('account_number', String, true)
    accountNumber: string = null;

    @JsonProperty('iban', String, true)
    iban: string = null;

    @JsonProperty('swift_code', String, true)
    swiftCode: string = null;

    @JsonProperty('currency', String, true)
    currency: string = null;

    @JsonProperty('documents', [Document], true)
    documents: Document[] = [];

    @JsonProperty('created_date', String, true)
    createdDate = null;

    @JsonProperty('updated_date', String, true)
    updatedDate = null;

    get address() {
        return this.streetAddress + '\n' + this.location;
    }

    get location() {
        return this.city + ', ' + this.country;
    }
}

